import PropTypes from 'prop-types';

export const DomainNotRegisteredProps = {
  locales: PropTypes.shape({
    title: PropTypes.func.isRequired,
    description: PropTypes.string,
    subtitle: PropTypes.string.isRequired,
    list: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  buttonsProps: PropTypes.shape({
    rightButton: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  domain: PropTypes.string,
};
